import React from 'react';
import { Box, FormHelperText, Typography } from '@mui/material';
import ActionPathEditor from './ActionPathEditor';


const ActionPathField = ({
  browseDisabled = false,
  browseLabel,
  caseid,
  disabled = false,
  error = false,
  helperText,
  label,
  onBrowse,
  onChange,
  placeholder,
  tags,
  value,
}) => (
  <Box>
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mb: 0.5, display: 'block' }}
      >
        {label}
      </Typography>
      <ActionPathEditor
        caseid={caseid}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        singleLine
        disabled={disabled}
        tags={tags}
        aria-label={typeof label === 'string' ? label : undefined}
        onBrowse={onBrowse}
        browseLabel={browseLabel}
        browseDisabled={browseDisabled}
      />
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </Box>
  </Box>
);

export default React.memo(ActionPathField);
